import { render, staticRenderFns } from "./DebtSummaryModal.vue?vue&type=template&id=84167592&"
import script from "./DebtSummaryModal.vue?vue&type=script&lang=ts&"
export * from "./DebtSummaryModal.vue?vue&type=script&lang=ts&"
import style0 from "./DebtSummaryModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports